/* eslint-disable react/require-default-props */
import React from 'react';
import { Logger } from '@saviynt/common';
import { Button, ModalIsland } from '@saviynt/design-system';

import './SafeBoundary.css';

const BUTTON_LABEL_REFRESH = 'Refresh';

interface SafeBoundaryProps extends React.PropsWithChildren {
  onError?: () => void;
}

interface SafeBoundaryState {
  isError: boolean;
}

class SafeBoundary extends React.Component<
  SafeBoundaryProps,
  SafeBoundaryState
> {
  constructor(props: SafeBoundaryProps) {
    super(props);
    this.state = { isError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    Logger.log('Error rendering forms: ', error, errorInfo);
    this.setState({ isError: true });

    const { onError } = this.props;

    if (onError) {
      onError();
    }
  }

  render(): React.ReactNode {
    const { isError } = this.state;
    const { children } = this.props;

    if (isError) {
      return (
        <ModalIsland
          kind='critical'
          alertTitle='Could not Load Page'
          alertSubtitle='We were unable to load the requested content.'
          onClose={() => {}}
          isCloseButtonVisible={false}
          isOpen
          primaryButton={
            <Button
              type='button'
              kind='filled'
              isEnabled
              size='medium'
              onClick={() => window.location.reload()}>
              {BUTTON_LABEL_REFRESH}
            </Button>
          }
        />
      );
    }

    return children;
  }
}

export default SafeBoundary;
